import { defineStore } from "pinia"

import { useApiStore } from "@/stores/api"
import { useMarkerStore } from "@/stores/marker"
import { useMarkercategoryStore } from "@/stores/markercategory"
import { useSettingsStore } from "@/stores/settings"
import { useShareStore } from "@/stores/share"
import { useTourStore } from "@/stores/tour"
import { useSyncStore } from "@/stores/sync"
import { useTrackerStore } from "@/stores/tracker"
import { useFeedbackStore } from "@/stores/feedback"

export const useRootStore = defineStore("root", () => {
	const resetAll = async () => {
		await useMarkerStore().reset()
		await useMarkercategoryStore().reset()
		await useShareStore().reset()
		await useTrackerStore().reset()
		await useSettingsStore().reset()
		await useSyncStore().reset()
		await useApiStore().reset()
		await useTourStore().reset()
		await useFeedbackStore().reset()
	}

	return {
		resetAll,
	}
})
